
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/broken/document-upload"}},[_c('path',{attrs:{"d":"M11.25 17.062V13.75l2.5 2.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.25 21.25V20M11.25 13.75l-2.5 2.5M2.5 11.25C2.5 5 5 2.5 11.25 2.5h6.25M27.5 12.5v6.25c0 6.25-2.5 8.75-8.75 8.75h-7.5C5 27.5 2.5 25 2.5 18.75v-2.525M22.5 12.5c-3.75 0-5-1.25-5-5v-5l10 10"}})])])
          )
        }
      }
    